module.exports = __webpack_public_path__ + "img/alarm-clock.ccb6a336.gif";